import type { WebsocketAiSmartCanvasMakeRealData } from '@freelancer/datastore/core';
import type { AiSmartCanvasMakeRealMessage } from './ai-smart-canvas-make-real.model';

export function transformAiSmartCanvasMakeReal(
  obj: WebsocketAiSmartCanvasMakeRealData,
): AiSmartCanvasMakeRealMessage {
  if (obj.result.length > 1) {
    throw new Error('AI Make Real result length is more than one');
  }

  return {
    id: obj.id,
    // When content is moderated, the result will be an empty array.
    returnValue:
      obj.result.length === 0
        ? 'Invalid content. Result is empty.'
        : obj.result[0].message,
    // Everything below this line are placeholders
    developerPrompt: '',
    base64Image: '',
    messages: '',
  };
}
